/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import Vue from 'vue';

import { normalizeRelations, resolveRelations } from '@/store/helpers';
import teamService from '@/services/team';

const state = {
    byId: {},
    allIds: [],
    setupIntent: '',
};

const getters = {
    // Return a single article with the given id.
    find: (state, _, __, rootGetters) => id =>
        // Swap ID referenes with the resolved author objects.
        resolveRelations(state.byId[id], ['location', 'channel', 'feature'], rootGetters),
    // Return a list of items in the order of `allIds`.
    list: (state, getters) => state.allIds.map(id => getters.find(id)),
    loaded: state => state.allIds.length > 0,
    id: (state, getters) => (getters.loaded ? state.allIds[0] : null),
    current: (state, getters) => getters.find(state.allIds[0]),
    hasFeature: (state, getters) => feature => _.find(
        getters.current.feature,
        o => o.attributes.feature === feature,
    ),
    hasServicesFeatures: (state, getters) => _.find(
        getters.current.feature,
        o => o.attributes.feature.startsWith('service-'),
    ),
    maxMonitors: (state, getters) => getters.current.meta.monitorCounters.up
            + getters.current.meta.monitorCounters.down
            + getters.current.meta.monitorCounters.pending
            >= getters.current.meta.planMonitors,
    setupIntent: state => state.setupIntent,
};

const actions = {
    load: async ({ commit }, teamId) => {
        const items = await teamService.getById(teamId);
        new Array(items.data).forEach((item) => {
            // Normalize nested data and swap the API response with an ID reference.
            commit('add', normalizeRelations(item, ['location', 'channel', 'feature']));
        });
        if (typeof items.included !== 'undefined') {
            items.included.forEach((item) => {
                // Add or update the included item.
                commit(`${item.type}/add`, item, {
                    root: true,
                });
            });
        }
    },
    clearAll: ({ commit }) => commit('clearAll'),
    setupIntent: async ({ commit, rootGetters }) => {
        const intent = await teamService.setupIntent(rootGetters['team/id']);
        commit('setupIntent', intent.meta.intent_secret);
    },
};

const mutations = {
    add: (state, item) => {
        Vue.set(state.byId, item.id, item);
        if (state.allIds.includes(item.id)) return;
        state.allIds.push(item.id);
    },
    clearAll: (state) => {
        state.byId = {};
        state.allIds = [];
        state.setupIntent = '';
    },
    setupIntent: (state, intentSecret) => {
        state.setupIntent = intentSecret;
    },
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
